import { useState } from 'react';
import type { AlgoliaStoreType } from '@storefront/lib-global';
import type { LocationDataType } from '@storefront/lib-global/globalComponents/locationComponent';

export const useStoresLocationInfo = () => {
  const [searchLocation, setSearchLocation] = useState<LocationDataType | undefined>(undefined);
  const [storesData, setStoresData] = useState<AlgoliaStoreType[]>([]);
  const [selectedStore, setSelectedStore] = useState('');
  return {
    storesData,
    setStoresData,
    selectedStore,
    setSelectedStore,
    searchLocation,
    setSearchLocation,
  };
};
